import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { RxComponent } from 'app/core/components/common/rx.component';

@Component({
  selector: 'itpx-filter-shared-box',
  templateUrl: './filter-box.component.html',
  styleUrls: ['./filter-box.component.css'],
  animations: [
    trigger('moreLess',
      [
        state('less', style({ height: '*' })),
        state('more, void', style({ height: '*' })),
        transition(
          'less <=> more', animate('0.4s ease-in-out'))
      ])]
})

export class FilterBoxSharedComponent extends RxComponent implements OnInit {
  // @Input() disableEmitter: Observable<boolean>;
  @Output() formStateChange = new EventEmitter<any>();
  @Input() config: FilterBoxConfiguration;

  private disabled: boolean;
  private form: FormGroup;
  private selectAll: FormControl;
  private selectAllChecked;
  private more: string = 'less';
  constructor() {
    super()
  }

  ngOnInit() {
    this.selectAll = new FormControl(true);
    this.selectAllChecked = this.config.options.every(it => it.checked);
    this.form = this.toFormGroup(this.config.options);

    this.selectAll.valueChanges.bindToLifecycle(this)
      .subscribe(res => {
        console.log(res);
        let input = {};
        Object.keys(this.form.controls).map(itr => input[itr] = res);
        this.form.setValue(input);
      })

    let event = this.form.valueChanges.share();

    event.debounceTime(800)
      .distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b))
      .bindToLifecycle(this)
      .subscribe(status => {
        this.formStateChange.emit({ id: this.config.key, status });
      });

    //Switch select all
    event.bindToLifecycle(this).subscribe(status => {
      this.selectAllChecked = Object.keys(status)
        .filter(it => status[it] === true).length === Object.keys(status).length;
      this.config.options.forEach(it => it.checked = status[it.key]);
      this.selectAll.setValue(this.selectAllChecked,
        { emitEvent: false })
    });
  }

  toFormGroup(questions: any[]) {
    let group: any = {};

    questions.forEach(question => {
      group[question.key] = question.required ? new FormControl(question.checked || false, Validators.required) : new FormControl(question.checked || false);
    });
    return new FormGroup(group);
  }

  private onClick() {
    this.more = this.more === 'more' ? 'less' : 'more';
  }

  private excludeRest(e: any) {
    let input = {};
    Object.keys(this.form.controls).filter(it => it !== e.key).map(itr => input[itr] = false);
    input[e.key] = true;
    this.form.setValue(input);
  }
}

export class FilterBoxConfiguration {
  title: string;
  key: string;
  show: boolean;
  state: string;
  options: { checked: boolean, key: string, required: boolean, value: string, frequency: number }[];
  // cutOffUpper: number; 
  cutOffLower: number;
  minOnly: number; //Show 'ONLY' button if options.length > minOnly 
}



// WEBPACK FOOTER //
// ./src/app/shared/components/filterable-grid/filter-group/filter-box.component.ts